// Atoms
import VmButtonLink from './atoms/vm-button-link/vm-button-link';

// Molecules
import VmClientDisclosure from './molecules/vm-client-disclosure/vm-client-disclosure';
import VmVideoCommentsListItem from './molecules/vm-video-comments-list-item/vm-video-comments-list-item';
import VmVideoCommentsList from './molecules/vm-video-comments-list/vm-video-comments-list';

// Organisms
import VmVideoComments from './organisms/vm-video-comments/vm-video-comments';

import VmChatbotLoader from './vm-chatbot-loader/vm-chatbot-loader';
import VmChatbotSkeleton from './vm-chatbot-skeleton/vm-chatbot-skeleton';

import VmListPagination from './vm-list-pagination/vm-list-pagination';
import VmLoadingSpinner from './vm-loading-spinner/vm-loading-spinner';
import VmProfileImage from './vm-profile-image/vm-profile-image';
import VmSortDropdown from './vm-sort-dropdown/vm-sort-dropdown';

import VmKolProfilePageHeader from './vm-kol-profile-page-header/vm-kol-profile-page-header';
import VmKolProfilePageVideoListItem from './vm-kol-profile-page-video-list-item/vm-kol-profile-page-video-list-item';
import VmKolProfilePageVideoList from './vm-kol-profile-page-video-list/vm-kol-profile-page-video-list';
import VmKolProfilePage from './vm-kol-profile-page/vm-kol-profile-page';

// Atoms
customElements.define('vm-button-link', VmButtonLink);

// Molecules
customElements.define('vm-video-comments-list', VmVideoCommentsList);
customElements.define('vm-video-comments-list-item', VmVideoCommentsListItem);
customElements.define('vm-client-disclosure', VmClientDisclosure);

// Organisms
customElements.define('vm-video-comments', VmVideoComments);

customElements.define('vm-chatbot-loader', VmChatbotLoader);
customElements.define('vm-chatbot-skeleton', VmChatbotSkeleton);

customElements.define('vm-list-pagination', VmListPagination);
customElements.define('vm-sort-dropdown', VmSortDropdown);
customElements.define('vm-loading-spinner', VmLoadingSpinner);
customElements.define('vm-profile-image', VmProfileImage);

customElements.define('vm-kol-profile-page', VmKolProfilePage);
customElements.define('vm-kol-profile-page-header', VmKolProfilePageHeader);
customElements.define('vm-kol-profile-page-video-list', VmKolProfilePageVideoList);
customElements.define('vm-kol-profile-page-video-list-item', VmKolProfilePageVideoListItem);
